<template>
  <component :is="tag" data-module="CmsArticleList">
    <slot :list="list" v-if="!loading"></slot>
  </component>
</template>

<script>
import {getArticles} from "~/api/CmsApi";

export default {
  name: 'CmsArticleList',
  props: {
    /**
     * 父栏目ID
     */
    pid: {
      type: [String, Number],
      default: ''
    },
    ids: {
      type: String,
      default: ''
    },
    /**
     * 分页查询起始页
     */
    page: {
      type: Number,
      default: 1
    },
    /**
     * 分页大小
     */
    limit: {
      type: Number,
      default: 100
    },
    /**
     * 指定元素渲染出的标签
     */
    tag: {
      type: String,
      default: 'div'
    },
    /**
     * 排序方式 0:时间倒序 1:sort值正序 2:ext1倒序（此时ext1为日期）
     */
    sortBy: {
      type: [String, Number],
      default: ''
    },
    parseFunction: {
      type: Function,
      default: obj => {
        return obj;
      }
    },
    isTop: {
      type: Boolean,
      default: true
    },
    query: {
      type: Object,
      default: () => ({})
    },
    // 头部插入置顶文章（用于景区公告、景区动态、文明旅游三个栏目）
    unshift: {
      type: Boolean,
      default: false
    },
    // 头部插入置顶文章后，剩余部分是否保持固定的条数（用于景区公告、景区动态、文明旅游三个栏目在一级页的展示）
    unshiftLimit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loading: true,
      list: []
    };
  },
  watch: {
    pid: {
      handler(value) {
        if (value) {
          console.log(value)
          this.initialize();
        }
      },
      immediate: true
    },
    ids: {
      handler(value) {
        if (value) {
          this.initialize();
        }
      },
      immediate: true
    },
    page: {
      handler() {
        this.$nextTick(() => {
          this.initialize();
        })
      }
    },
    limit: {
      handler() {
        this.$nextTick(() => {
          this.initialize();
        })
      }
    }
  },
  methods: {
    /**
     * 初始化数据
     */
    async initialize() {
      const param = Object.assign({ page: this.page, limit: this.limit }, this.query);
      let topList = [];
      if (this.unshift) {
        if (this.page == 1) {
          const topRes = await getArticles({
            page: 1,
            limit: 99999,
            cateId: this.pid,
            ext2: '置顶文章'
          });
          // topList = topRes.data.records || [];
        }
        param.ext2Empty = true;
      }

      if (this.sortBy) {
        param.sortBy = this.sortBy;
      }
      // 以ids为高优先级，传入了ids则pid不生效
      if (this.ids) {
        param.ids = this.ids.split(',');
      } else if (this.pid) {
        param.cateId = this.pid;
      } else
		return false;
      getArticles(param).then(res => {
        if (res.code === 0) {
          let list = res.data.records || [];

          topList.forEach(item => {
            list.unshift(item);
          });

          if (this.unshiftLimit) {
            list = list.slice(0, this.limit);
          }
          this.list = list.map(item => {
            return this.parseFunction(item);
          });

          this.$emit('loaded', list, res.data.total);
        } else {
          console.warn('文章信息获取失败');
        }
        this.loading = false;
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cms/CmsArticleList.vue